import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=db470b6e&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db470b6e')) {
      api.createRecord('db470b6e', component.options)
    } else {
      api.reload('db470b6e', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=db470b6e&", function () {
      api.rerender('db470b6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bCKjbZwQ5SMt/JS/cancellationPolicy.vue"
export default component.exports